import searchFilter from './SearchFilter'
import searchManual from './SearchManual'
import tagHierarchy from './TagHierarchy'

export default {
  tabs: [
    {
      key: 'search',
      label: 'Search Filters'
    },
    {
      key: 'manual',
      label: 'Enter Ad Codes'
    }
  ],
  searchManual,
  searchFilter,
  tagHierarchy
}

export { searchManual, searchFilter, tagHierarchy }



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/selection/Search/index.js